<template>
	<v-row>
		<v-col>
			<v-form

				v-model="formIsValid.images"
				ref="imageForm"
				class="mb-8"
			>
				<ui-box :form="$refs.imageForm" :eager="!!localPass.id" :additional-validations="[hasImage]">
					<!-- Advanced Image -->
					<v-row>
						<v-col>
							<h5>Mobile Pass Header Image</h5>
							<span class="grey--text text--darken-1 text-body-2">
							</span>
						</v-col>
					</v-row>
					<span class="grey--text text--darken-1 text-body-2">
					</span>
					<v-divider class="mb-6 mt-4 opacity-80"></v-divider>
					<v-row>
						<template v-for="(media, idx) in localPass.media.filter(x => x.location == 'Hero')">
							<bw-image
								v-model="localPass.media[idx]"
								:key="`media-${media.id}`"
								class="rounded-lg"
								:upload-assignment="'deal'"
								:upload-assignment-id="localPass.id"
							></bw-image>
						</template>
					</v-row>
					<!-- End: Advanced Image -->
				</ui-box>
			</v-form>

			<save-form
				:refs="$refs"
				:additional-validations="[isFormValid]"
				:is-saving="isSaving"
				:save-text="saveText"
				@cancel-action="cancelChanges"
				@save-action="saveDestination"
			></save-form>

		</v-col>
	</v-row>
</template>

<script>

import customizationMixin from './Mixins/customizationMixin';

export default {
	name: 'CustomizeImage',
	mixins: [customizationMixin],
	data() {
		return {
			formIsValid: {images: false},
		};
	},
	mounted() {
		if (this.localPass.media.length === 0) {
			this.$set(this.localPass.media, 0, {
				location: 'Hero',
				name: 'Hero',
				url: '/images/placehold.co.png',
				minDimensions: '1280x640',
				cropperSettings: {
					limitAR: '2:1',
					x: 0,
					y: 0
				}
			});

		} else {
			this.$set(this.localPass.media, 0, {
				...this.localPass.media[0],
				minDimensions: '1280x640',
				cropperSettings: {
					limitAR: '2:1',
					x: 0,
					y: 0
				}
			});
		}
		this.sections = this.extraData.sections;
		this.localPass = {...this.localPass};
	},
	computed: {
		hasImage() {
			return !!this.localPass?.media?.length && this.localPass.media[0].url !== 'https://placehold.co/1280x640';
		},

		isFormValid() {
			return this.hasImage;
		},
	},
};
</script>